<!--
     <MenuSelector />

     Public methods:
      - show()
      - hide()
      
-->

<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      fixed
      :temporary="!site_selector"
      :stateless="site_selector"
      class="menu-selector-drawer"
    >
      <div class="menu-selector-header">
        <v-icon medium @click="hide">mdi-close</v-icon>
        <v-spacer></v-spacer>
        <div
          class="qmkey-toolbar-menu-image-cont"
        >
          <img
          class="qmkey-toolbar-menu-image menu-selector-img"
          :src="site_logo"
          @click="open_site_selector"
          />
        </div>
      </div>
  
      <v-divider class="menu-selector-divider"></v-divider>
  
      <v-list class="menu-selector-list" nav ref="itemlist">
          <v-list-group
            v-for="(menu,index) in all_menus_tree"
            :key="menu.id"
            v-if="menu.enabled"
            content-class="qmkey-toolbar-menu-contents elevation-1"
            v-model="opened[index]"
            
          >
            <template v-slot:activator>
              <v-list-item-title>
                <span class="large-text">{{menu.name}}</span>
              </v-list-item-title>
            </template>
            <div class="header-menu-content-mobile">
              
              <v-treeview
              dense
              :items="menu.children"
              class="qmkey-treeview-navegation-menu pt-0 pb-0"
              :active="currentMenus.map(it => it.id)"
              :open="currentMenus.map(it => it.id)"
              style="background-color: white;"
              hoverable
              multiple-active
            >
              <template v-slot:label="{item}">
                <div
                  v-if="item.url"
                  :disabled="!item.url"
                  :class="[item.url ? 'qmkey-toolbar-menu-item' : 'qmkey-toolbar-menu-item-disabled grey--text text--darken-4 v-subheader subheader']"
                  :input-value="is_menu_active(item)"
                  active-class="qmkey-toolbar-menu-item-active"
                  @click="goToMenu(item)"
                >
                  {{ item.name }}
                </div>
                <div
                  class="grey--text text--darken-4" 
                  v-else
                  style="font-weight: bolder;"
                >
                  {{item.name}}
                </div>
              </template>
            </v-treeview>
              
            </div>
          </v-list-group>
      </v-list>
    </v-navigation-drawer>
    
    <SiteSelector
      ref="siteselector"
      @close="site_selector_state = false"
    />

  </div>
</template>
  
  
<style lang="scss">
  @import "@/sass/header.scss";
  .large-text {
    font-size: large;
  }
  .x-small-text {
    font-size: x-small;
  }
  .menu-selector-img {
    width: auto !important;
    margin-bottom: 0.3em !important;
  }
  .menu-selector-drawer {
    width: 15em;
    pointer-events: auto !important;
  }
</style>
  
  
<script>
  import { mapGetters, mapState } from 'vuex'
  import SiteMenuItem from '@/components/header/SiteMenuItem'
  import SearchTextAdmin from '@/components/header/SearchTextAdmin'
  import SiteSelector from '@/components/header/SiteSelector'
  import QTree from '@/utils/QTree';
  
  export default {
    name: "MenuSelector",
  
    components: {
      SiteMenuItem,
      SearchTextAdmin,
      SiteSelector,
    },
  
    props: {
       focus_active: {type: Boolean, default: true},
       site_logo: {},
       
    },
  
    data: () => ({
      drawer: false,
      search: '',
      opened: [],
      site_selector_state: false,
    }),
  
    computed: {
      ...mapGetters([ 'isAdmin']),
      ...mapState(['menus']),

      adminViews(){ 
        return [{ // Admin menu
            id: -1,
            name: 'Admin',
            enabled: this.isAdmin,
            order: 0,
            parent: null,
            path: '/',
            site: null,
            url: null,
            items: [{
                id: -2,
                enabled: this.isAdmin,
                order: 0,
                path: '/',
                site: null,
                name: 'Sites',
                url: '/sites',
                items: [],
              }, {
                id: -3,
                enabled: true,
                order: 0,
                path: '/',
                site: null,
                name: 'Users',
                url: '/users',
                items: [],
              }, {
                id: -4,
                enabled: true,
                order: 0,
                path: '/',
                site: null,
                name: 'Menus',
                url: '/menus',
                items: [],
              }, {
                id: -5,
                enabled: true,
                order: 0,
                path: '/',
                site: null,
                name: 'Vocabulary',
                url: '/vocabularies',
                items: [],
              }, {
                id: -6,
                enabled: true,
                order: 0,
                path: '/',
                site: null,
                name: 'Roles',
                url: '/roles',
                items: [],
              }, {
                id: -7,
                enabled: true,
                order: 0,
                path: '/',
                site: null,
                name: 'BPExplorer',
                url: '/bpexplorertable',
                items: [],
              }, {
                id: -8,
                enabled: true,
                order: 0,
                path: '/',
                site: null,
                name: 'Mapa de Procesos',
                url: '/processes',
                items: [],
              }],
        }];
      },
      allmenus() {
        return this.adminViews.concat(this.menus);
      },
      currentMenus() {
       // Returns [{menu}, {submenu}, {subsubmenu}] or []
       function url2regex(url) {
         // https://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
         return new RegExp(url.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&') + "(&|$)");
       }
       function exploreSubmenus(url, menus) {
         // Parameter menus is a list of menus: [{menu}, {menu}]
         // Returns [{menu}, {submenu}, {subsubmenu}] or null
         // WARNING: compares urls with url.split('&')[0].
         //          TODO: Fix this behaviour in a business_process urls refactor.
         for (const menu of (menus || [])) {
          if (menu.enabled) {
           if (menu.url && url2regex(menu.url).test(url))
             return [menu];
           let match = exploreSubmenus(url, menu.items);
           if (match)
             return ([menu]).concat(match);
          }
         }
         return null;
       }
       // Tell Vue that we are watching this.$route, otherwise it won't update me
       this.$route;
       return exploreSubmenus(this.$router.currentRoute.fullPath, this.allmenus) || [];
     },
     site_selector() {
      return this.site_selector_state
     },
     all_menus_tree() {/*.filter_funct((it)=> {return it.enabled})*/
      const tree = new QTree(this.allmenus.map(men => ({...men,'children': men.items}))).map((it) => ({...it,'children': it.items})).filter('enabled',true);
      tree.custom_tree_sort('order');
      return tree.get_array_tree();
     }
    },
  
    methods: {
      // Public methods ////////////////
      show() {
        this.drawer = true;
        this.opened = this.all_menus_tree.map(m => this.currentMenus.some(menu => menu.id === m.id));
      },
  
      hide() {
        this.drawer = false;
      },
      //////////////////////////////////
      is_menu_active(menu) {
        return this.currentMenus.some(m => m.id === menu.id);
      },
      goToMenu(menu) {
       if (!menu.url || menu.url == this.$router.currentRoute.fullPath)
         return;
       this.$router.push(menu.url.replace(/^\//, ''));
      },
      open_site_selector() {
        this.$refs.siteselector.show();
        this.site_selector_state = true;
      },
    },
  }
</script>
  